(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    addStyle();
    addBanner();
  }

  function addStyle() {
    let style = document.createElement("style");
    style = document.createElement("style");
    style.textContent = `
      body:has(.myhomebundle-overlay:not(.hide)) {
        overflow: hidden;
      }
      .myhomebundle-poster {
        cursor: pointer;
      }
      .myhomebundle-overlay {
        position: fixed;
        inset: 0;
        width: 100%;
        height: 100%;
        background: #00000070;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 1rem;
        z-index: 10000;
      }
      .myhomebundle-box {
        position: relative;
        width: 100%;
        max-width: 1000px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1rem;
        background: #fff;
      }
      .myhomebundle-box .close-btn {
        position: absolute;
        top: 8px;
        right: 8px;
        display: flex;
        cursor: pointer;
      }
      .myhomebundle-box .close-btn svg {
        width: 25px;
        height: 25px;
      }
      .myhomebundle-box .swiper-slide {
        height: auto !important;
      }
      .myhomebundle-box p {
        margin: 0;
      }
      .myhomebundle-box > .title {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 6px;
        text-align: center;
      }
      .myhomebundle-box .subtitle {
        font-size: 14px;
        text-align: center;
      }
      .myhomebundle-box .category-wrapper {
        width: 100%;
        margin-top: 1rem;
        padding: 1rem;
        background: #EFEFEF;
      }
      .myhomebundle-box .category-wrapper .carousel-button {
        height: 100%;
        display: none;
        align-items: center;
        justify-content: center;
        background: #fff;
        cursor: pointer;
      }
      .myhomebundle-box .category-wrapper .carousel-button.swiper-button-disabled {
        background: #FFFFFFB2;
        cursor: default;
      }
      .myhomebundle-box .category-wrapper .carousel-button.swiper-button-disabled svg {
        fill: #CCCCCC;
      }
      .myhomebundle-box .category-wrapper .carousel-button svg {
        width: 30px;
        transition: fill .3s;
      }
      .myhomebundle-box .category-wrapper .carousel-button:not(.swiper-button-disabled):active svg {
        transform: scale(0.9);
      }
      .myhomebundle-box .carousel-wrapper.desktop {
        display: none;
      }
      .myhomebundle-box .category-item-group {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 6px;
      }
      .myhomebundle-box .category-item {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 1rem;
        background: #fff;
        user-select: none;
      }
      .myhomebundle-box .category-item .title {
        font-size: 12px;
        font-weight: 600;
      }
      .myhomebundle-box .category-item .subtitle {
        display: none;
        font-size: 7px;
      }
      .myhomebundle-box .category-item .link-wrapper {
        width: 100%;
        margin-top: auto;
        padding-top: 1rem;
      }
      .myhomebundle-box .category-item a {
        width: 100%;
        display: block;
        padding: 6px 12px;
        margin: 0;
        background: #990000;
        color: #fff;
        text-align: center;
        font-size: 9px;
        font-weight: 400;
        border: 0;
        border-radius: 0;
      }
      .myhomebundle-box .carousel-pagination {
        text-align: center;
        --swiper-pagination-color: #000;
      }
      .myhomebundle-box .carousel-pagination.desktop {
        display: none;
      }

      @media (min-width: 1024px) {
        .myhomebundle-box {
          padding: 30px;
        }
        .myhomebundle-box .category-wrapper {
          display: grid;
          grid-template-columns: 50px minmax(0, 1fr) 50px;
          align-items: center;
          gap: 10px;
          margin-top: 30px;
        }
        .myhomebundle-box .category-item .title {
          font-size: 20px;
        }
        .myhomebundle-box .category-item .subtitle {
          font-size: 14px;
        }
        .myhomebundle-box .category-item a {
          font-size: 16px;
        }
        .myhomebundle-box .category-wrapper .carousel-button {
          display: flex;
        }
        .myhomebundle-box .carousel-wrapper.desktop,
        .myhomebundle-box .carousel-pagination.desktop {
          display: block;
        }
        .myhomebundle-box .carousel-wrapper.mobile,
        .myhomebundle-box .carousel-pagination.mobile {
          display: none;
        }
      }
    `;
    document.head.append(style);
  }

  function addBanner() {
    const desktopImage = document.createElement("img");
    desktopImage.src =
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/MyHomeBundleDesktop.jpg?v=1772187260";
    desktopImage.classList.add("hide-mobile", "myhomebundle-poster");
    desktopImage.style.width = "100%";
    desktopImage.draggable = false;

    const mobileImage = document.createElement("img");
    mobileImage.src =
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/MyHomeBundleMobile.jpg?v=1772187260";
    mobileImage.classList.add("hide-desktop", "myhomebundle-poster");
    mobileImage.style.width = "100%";
    mobileImage.draggable = false;

    $(".cart-main").prepend(desktopImage).append(mobileImage);

    addPopup();
  }

  function addPopup() {
    const overlay = document.createElement("div");
    overlay.classList.add("myhomebundle-overlay", "hide");

    const data = getData();
    const mobileData = data.reduce((result, item, index) => {
      const chunkIndex = Math.floor(index / 4);
      if (!result[chunkIndex]) result[chunkIndex] = [];
      result[chunkIndex].push(item);
      return result;
    }, []);

    const box = document.createElement("div");
    box.classList.add("myhomebundle-box");
    box.innerHTML = `
      <div class="close-btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/></svg>
      </div>
      <p class="title">Bundle & Save with MyHomeBundle</p>
      <p class="subtitle">Complete your bundle with a popular add-on</p>
      <div class="category-wrapper">
        <div class="carousel-button button-prev">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M169.4 297.4C156.9 309.9 156.9 330.2 169.4 342.7L361.4 534.7C373.9 547.2 394.2 547.2 406.7 534.7C419.2 522.2 419.2 501.9 406.7 489.4L237.3 320L406.6 150.6C419.1 138.1 419.1 117.8 406.6 105.3C394.1 92.8 373.8 92.8 361.3 105.3L169.3 297.3z"/></svg>
        </div>
        <div class="carousel-wrapper desktop">
          <div class="swiper">
            <div class="swiper-wrapper">
              ${data
                .map(
                  (item) => `
                    <div class="swiper-slide">
                      <div class="category-item" data-category="${item.category}">
                        <img src="${item.image}" alt="" width="" height="" />
                        <p class="title">${item.title}</p>
                        <p class="subtitle">${item.subtitle}</p>
                        <div class="link-wrapper">
                          <a href="${item.url}">${item.btnText}</a>
                        </div>
                      </div>
                    </div>
                  `,
                )
                .join("")}
            </div>

            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="carousel-wrapper mobile">
          <div class="swiper">
            <div class="swiper-wrapper">
              ${mobileData
                .map((list) => {
                  return `
                    <div class="swiper-slide">
                      <div class="category-item-group">
                        ${list
                          .map(
                            (item) => `
                              <div class="category-item" data-category="${item.category}">
                                <img src="${item.image}" alt="" width="" height="" />
                                <p class="title">${item.title}</p>
                                <p class="subtitle">${item.subtitle}</p>
                                <div class="link-wrapper">
                                  <a href="${item.url}">${item.btnText}</a>
                                </div>
                              </div>
                            `,
                          )
                          .join("")}
                      </div>
                    </div>
                  `;
                })
                .join("")}
            </div>

            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="carousel-button button-next">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/></svg>
        </div>
      </div>
      <div class="carousel-pagination desktop"></div>
      <div class="carousel-pagination mobile"></div>
    `;

    overlay.append(box);
    document.body.append(overlay);

    const desktopSwiper = new Swiper(
      ".myhomebundle-box .carousel-wrapper.desktop .swiper",
      {
        slidesPerView: 3,
        spaceBetween: 10,

        observer: true,
        observeParents: true,

        pagination: {
          el: ".myhomebundle-box .carousel-pagination.desktop",
          clickable: true,
        },

        navigation: {
          nextEl: ".myhomebundle-box .button-next",
          prevEl: ".myhomebundle-box .button-prev",
        },
      },
    );

    const mobileSwiper = new Swiper(
      ".myhomebundle-box .carousel-wrapper.mobile .swiper",
      {
        slidesPerView: 1,
        spaceBetween: 10,

        observer: true,
        observeParents: true,

        pagination: {
          el: ".myhomebundle-box .carousel-pagination.mobile",
          clickable: true,
        },
      },
    );

    handleEventListener();
  }

  function handleEventListener() {
    $(".myhomebundle-poster").on("click", openPopup);

    $(".myhomebundle-overlay").on("click", function (e) {
      if (this == e.target) {
        closePopup();
      }
    });

    $(".myhomebundle-box .close-btn").on("click", closePopup);
  }

  function openPopup() {
    $(".myhomebundle-overlay").removeClass("hide");
  }

  function closePopup() {
    $(".myhomebundle-overlay").addClass("hide");
  }

  function getData() {
    const data = [
      {
        image:
          "//prismplus.sg/cdn/shop/files/Products-Monitors_4ea011d4-b10f-45b9-bd35-fd4c4fec1712.png?v=1726733723",
        title: "Monitors",
        subtitle: "Power your home office",
        btnText: "Shop Monitors",
        url: "/collections/gaming-monitors",
        category: "Monitor",
      },
      {
        image:
          "https://prismplus.sg/cdn/shop/files/Products-TV2_2c3882fd-6509-4d7e-a2e7-bbec1f5f9460.png?v=1734187145",
        title: "Google TVs",
        subtitle: "Your living room centrepiece",
        btnText: "Shop TVs",
        url: "/collections/tvs",
        category: "TV",
      },
      {
        image:
          "https://prismplus.sg/cdn/shop/files/Aircon_c579dc04-2c89-4106-b8ff-29f4d99299a8.png?v=1752051356",
        title: "Air Conditioner",
        subtitle: "Essential comfort upgrade",
        btnText: "Shop Aircons",
        url: "/products/prism-neo",
        category: "Aircon",
      },
      {
        image:
          "https://prismplus.sg/cdn/shop/files/Products-Fridge-CV.png?v=1726733951",
        title: "Fridges",
        subtitle: "Common home essential",
        btnText: "Shop Fridges",
        url: "/collections/refrigerators",
        category: "Fridge",
      },
      {
        image:
          "https://prismplus.sg/cdn/shop/files/Products-Fans_1c88ee36-18e4-4940-8ba3-7ccc1c6076cd.png?v=1751010929",
        title: "Ceiling Fans",
        subtitle: "Easy bundle add-on",
        btnText: "Shop Ceiling Fans",
        url: "/collections/smart-ceiling-fans",
        category: "Ceiling Fan",
      },
      {
        image:
          "https://prismplus.sg/cdn/shop/files/products-laundry.png?v=1759389274",
        title: "Laundry",
        subtitle: "Complete your home setup",
        btnText: "Shop Laundry",
        url: "/collections/laundry-appliances",
        category: "Laundry",
      },
      {
        image:
          "https://prismplus.sg/cdn/shop/files/Products-Smart_Locks.png?v=1726733963",
        title: "Smart Locks",
        subtitle: "Upgrade your home security",
        btnText: "Shop Smart Locks",
        url: "/collections/locks",
        category: "Lock",
      },
      {
        image:
          "https://prismplus.sg/cdn/shop/files/Products-AirPurifiers_1.png?v=1726733879",
        title: "Air Purifiers",
        subtitle: "Health-first home upgrade",
        btnText: "Shop Air Purifiers",
        url: "/collections/smart-air-purifiers",
        category: "Air Purifier",
      },
      {
        image:
          "https://prismplus.sg/cdn/shop/files/Products-Robovac_4ecc3fcf-2eb0-468a-bdc1-adeb62e6e38c.png?v=1762307672",
        title: "Vacuums",
        subtitle: "Keep your new home spotless",
        btnText: "Shop Vacuums",
        url: "/collections/vacuum",
        category: "Vacuum",
      },
      {
        image:
          "https://prismplus.sg/cdn/shop/files/Products-Soundbar_2f715f6f-f6bb-4eec-bd05-2d3e4446611f.png?v=1726733722",
        title: "Soundbars",
        subtitle: "Complete your cinematic setup",
        btnText: "Shop Soundbars",
        url: "/collections/soundbar",
        category: "Soundbar",
      },
    ];

    return data;
  }
})();
